import React, { createContext, useContext } from "react";

interface PermissionProviderProps {
  permissions?: number[] | null;
  children: React.ReactNode;
}

const PermissionContext = createContext<number[]>([]);

export const usePermission = (permission: number | null) => {
  const permissions = useContext(PermissionContext);
  return permission ? permissions.includes(permission) : false;
};

export const useAnyPermission = (list: any[]) => {
  const permissions = useContext(PermissionContext);
  return list.some(
    (item) => permissions.includes(item.requiredPermissions)
    // ||
    //   !item.requiredPermissions
  );
};

const PermissionProvider: React.FC<PermissionProviderProps> = ({
  permissions,
  children,
}) => {
  return (
    <PermissionContext.Provider value={permissions || []}>
      {children}
    </PermissionContext.Provider>
  );
};

export default PermissionProvider;
